import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {DatePipe} from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class EdlNgbDateParserFormatter extends NgbDateParserFormatter {
    datePipe = new DatePipe('en-US');

    constructor(@Inject(String) private dateFormatString: string) {
        super();
    }

    format(date: NgbDateStruct | null): string {
        if (date === null) {
            return '';
        }
        try {
            let d = new Date(date.year, date.month - 1, date.day);
            return this.datePipe.transform(d, this.dateFormatString) ?? '';
        } catch (e) {
            return '';
        }
    }

    parse(value: string): NgbDateStruct | null {
        let retVal: NgbDateStruct | null;

        if (!value) {
            retVal = null;
        } else {
            try {
                const dateTransform = this.datePipe.transform(value, 'M-d-y');
                if (dateTransform) {
                    const dateParts = dateTransform.split('-');
                    retVal = { year: parseInt(dateParts[2]), month: parseInt(dateParts[0]), day: parseInt(dateParts[1]) };
                } else {
                    retVal = null;
                }
            }
            catch (e) {
                retVal = null;
            }
        }

        return retVal;
    }
}